import type { Building } from "building-types/building/buildingTypes";
import type { Doc } from "building-types/doc";
import type { TargetedOpeningSettings } from "building-types/openings/opening";
import type { PartialHomeSettings } from "building-types/settings/homeSettings";
import { mergeSettingsForEntity } from "doc/mergeSettingsSet";
import { getDocEntityIdFromGeneratedRoomLayoutEligibleEntity } from "doc/rooms/layout/roomLayoutTools";

export default function getTargetedOpeningSettings(
  building: Pick<Building, "settingsSets" | "optionChoices" | "settings" | "windowPlacements" | "doorPlacements">,
  doc: Pick<Doc, "settings" | "entitySettings">,
): TargetedOpeningSettings {
  const { settingsSets, optionChoices, settings: finalHomeSettings } = building;
  const { settings, entitySettings } = doc;

  const targetedOpeningSettingsTable: { [openingId: string]: PartialHomeSettings } = {};

  for (const id in building.windowPlacements) {
    const window = building.windowPlacements[id];
    const windowId = getDocEntityIdFromGeneratedRoomLayoutEligibleEntity(window);
    if (!windowId) {
      continue;
    }
    const windowEntitySettings = mergeSettingsForEntity(
      entitySettings,
      windowId,
      settingsSets,
      settings,
      optionChoices,
    );

    Object.assign(targetedOpeningSettingsTable, {
      [windowId]: { windowFraming: { ...finalHomeSettings.windowFraming, ...windowEntitySettings.windowFraming } },
    });
  }

  for (const id in building.doorPlacements) {
    const door = building.doorPlacements[id];
    const doorId = getDocEntityIdFromGeneratedRoomLayoutEligibleEntity(door);
    if (!doorId) {
      continue;
    }

    const doorEntitySettings = mergeSettingsForEntity(entitySettings, doorId, settingsSets, settings, optionChoices);

    Object.assign(targetedOpeningSettingsTable, {
      [doorId]: { doorFraming: { ...finalHomeSettings.doorFraming, ...doorEntitySettings.doorFraming } },
    });
  }

  return targetedOpeningSettingsTable;
}
